import React from 'react';
import { NavLink } from 'react-router-dom';
import i18next from 'i18next';
import { connect } from 'react-redux';
import ChangePasswordForm from '../Form/ChangePasswordForm';
import { ModalsConsumer } from '../Modal/ModalsProvider';
import PromocodeForm from '../Form/PromocodeForm';
import Icon from '../Icon/Icon';
import promocodeIcon from 'icons/promocode.svg';

class Profile extends React.PureComponent {
  render() {
    return (
      <div className="profile">
        <ModalsConsumer>
          {({ showModal }) => (
            <div className="profile__menu" key="menu">
              <div
                className="profile__menu-item profile__menu-item--blue text-icon"
                onClick={() => showModal(<PromocodeForm />)}
              >
                <Icon glyph={promocodeIcon} className="text-icon__icon" />
                <span>{i18next.t('blocks.promocodes')}</span>
              </div>
              <NavLink
                to="/wallet"
                className="profile__menu-item"
              >
                {i18next.t('blocks.wallet')}
              </NavLink>
            </div>
          )}
        </ModalsConsumer>
        <div className="profile__form">
          <ChangePasswordForm />
        </div>
      </div>
    );
  }
}

export default connect((state) => {
  return {
    pathname: state.router.location.pathname,
    profile: state.user.profile,
  };
}, {})(Profile);



// WEBPACK FOOTER //
// ./app/components/Profile/Profile.jsx